import { User } from './user';
import { MunchedImage } from 'sb-lib/types';

export enum HelpCenterArticleStatus {
  published = 'published',
  draft = 'draft',
  hidden = 'hidden',
}

export interface HelpCenterArticle {
  id: number;
  title: string;
  slug: string;
  articleCollectionId: number | undefined;
  userId: number;
  user: User;
  description: string;
  content: string;
  status: HelpCenterArticleStatus;
  dateUpdated: number;
  dateCreated: number;
  count: number;
  images?: MunchedImage[];
  imageIds?: string[];
}

export interface HelpCenterCollection {
  id: number;
  title: string;
  slug: string;
  color: string;
  articles: object;
  collectionArticleCount: number;
}

export interface HelpCenterSettings {
  orgId: number;
  name: string | null;
  publishedArticlesCount: number;
  title?: string | null;
  backgroundImageUrl?: string | null;
  homeUrl?: string | null;
  logoUrl?: string | null;
  domainlink: DomainLink | null;
}

export interface DomainLink {
  domain: string;
  vercelVerified: boolean;
  vercelVerificationTxtName: string;
  vercelVerificationTxtValue: string;
  dnsConnected: boolean;
}
